import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ApplicationPage = lazy(() => import('../views/list/ApplicationPage'));

export function ApplicationPageLazy() {
	return (
		<PageSuspense>
			<ApplicationPage />
		</PageSuspense>
	);
}
